import {Component, OnInit} from '@angular/core';
import {AVAILABLE_LANGS, LANGUAGE_DISPLAY_NAMES, TranslationService} from '../../services/translation.service';

@Component({
  selector: 'language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {

  selectedLanguage;
  availableLanguages;
  displayNameByLanguage = LANGUAGE_DISPLAY_NAMES;

  constructor(private translationService: TranslationService) {
  }

  ngOnInit() {
    this.selectedLanguage = this.translationService.getCurrentLanguage();
    this.availableLanguages = AVAILABLE_LANGS;
  }

  selectedLanguageChanged() {
    this.translationService.setCurrentLanguage(this.selectedLanguage);
  }
}
